import LegBuilder from "./builders/LegBuilder";
const defaultLegBuilders = [
  new LegBuilder().setDurationTime(30).setNumberOfIntermediatePoints(2).setTSIRealTimeStatus("ONTIME").addLegAmenities(2).addTSILegDisruptions(4),
  new LegBuilder().isTransferLeg().setDurationTime(7),
  new LegBuilder().setDurationTime(43).setNumberOfIntermediatePoints(2),
  new LegBuilder().setConnectionTime(10).setNumberOfIntermediatePoints(1).setTSIRealTimeStatus("DELAYED")
];
const mockJLTProps = (idx, legBuilders = defaultLegBuilders, { syncLegs = true, debug = false } = {}) => {
  if (syncLegs) {
    legBuilders.forEach((legBuilder, i) => {
      if (i > 0)
        legBuilder.syncWithPreviousLeg(legBuilders[i - 1]);
    });
  }
  const legs = legBuilders.map((legBuilder) => {
    return legBuilder.buildLeg();
  });
  const tsiLegs = legBuilders.map((legBuilder) => {
    return legBuilder.buildTSILeg();
  });
  if (debug) {
    console.log("Legs", legs);
    console.log("TSILegs", tsiLegs);
  }
  const journey = { id: `journey-plan-${idx}`, legs };
  return {
    locale: "en-gb",
    journey
  };
};
var mockJLTProps_default = mockJLTProps;
export {
  mockJLTProps_default as default
};
